<template>
  <div class="mt-1">
    <div>
      <h2 class="grey darken-2 pa-2 white--text">Settings</h2>
      <v-card flat>
        <v-layout row wrap class="white">
          <v-flex xs12 md3 class="pt-1">
            <v-tooltip top>
              <v-btn medium flat router to="/uprofile" slot="activator">
                <v-icon left x-large>border_color</v-icon>
                <span>Update Profile</span>
              </v-btn>
              <span>Update your organisation profile</span>
            </v-tooltip>
          </v-flex>

          <v-flex xs12 md3 class="pt-1">
            <v-tooltip top>
              <v-btn medium flat router to="/upload" slot="activator">
                <v-icon left x-large>add_a_photo</v-icon>
                <span>Add Logo</span>
              </v-btn>
              <span text--white>Upload your Organization logo</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs12 md3 class="pt-1">
            <v-tooltip top>
              <v-btn medium flat router to="trainers" slot="activator">
                <v-icon left x-large>people_outline</v-icon>
                <span>Add Trainers</span>
              </v-btn>
              <span>Add trainers for your organisation</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs12 md3 class="pt-1">
            <v-tooltip top>
              <v-btn medium flat @click="dialog = true" slot="activator">
                <v-icon left x-large>lock_open</v-icon>
                <span>Change Password</span>
              </v-btn>
              <span text--white>Change Login Password</span>
            </v-tooltip>
            <v-dialog v-model="dialog" width="500">
              <v-card v-for="user in userdata" :key="user.id">
                <v-card-title
                  class="headline text-xs-center indigo white--text"
                >Confirm Password Change</v-card-title>
                <v-card-text></v-card-text>
                <v-card-actions>
                  <v-btn
                    color="indigo darken-2 white--text"
                    @click="resetPassword(user.email)"
                  >Send Reset Email</v-btn>
                  <v-btn color="grey lighten-3" @click="dialog = false">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-card>
      <v-divider class="pt-2"></v-divider>
    </div>
    <v-alert v-if="success" :value="true" :type="alerttype">
      {{alert}}
      <v-btn fab small @click="success=!success">
        <v-icon color="red darken-4" medium>close</v-icon>
      </v-btn>
    </v-alert>
    <v-layout row class="white">
      <v-flex xs12 sm12 offset-sm0>
        <v-card right>
          <v-list class="white" two-line>
            <v-list-tile v-for="user in userdata" :key="user.id">
              <v-list-tile-content>
                <v-list-tile-title></v-list-tile-title>
                <h2>{{user.name}}</h2>
                <v-list-tile-sub-title>Website: {{user.website}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-card-title primary-title>
              <div v-for="user in userdata" :key="user.id">
                <h2 class="teal lighten-5">Organisation Profile</h2>
                <div>{{user.about}}</div>

                <h2 class="teal lighten-5">Primary Contact</h2>
                <div>
                  <v-icon color="teal">person</v-icon>
                  {{user.contact}}
                </div>
                <div>
                  <v-icon color="teal">phone</v-icon>
                  {{user.phone}}
                </div>
                <div>
                  <v-icon color="teal">email</v-icon>
                  {{user.email}}
                </div>
                <h2 class="teal lighten-5">Secondary Contact</h2>
                <div>
                  <v-icon color="teal">person</v-icon>
                  {{user.contact1}}
                </div>
                <div>
                  <v-icon color="teal">phone</v-icon>
                  {{user.phone1}}
                </div>
                <div>
                  <v-icon color="teal">email</v-icon>
                  {{user.email1}}
                </div>
              </div>
            </v-card-title>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { db, auth, functions } from "@/fb";

export default {
  data() {
    return {
      userid: "",
      dialog: false,
      success: false,
      alerttype: "",
      name: "",
      about: "",
      email: "",
      email1: "",
      phone1: "",
      phone: "",
      contact: "",
      contact1: "",
      photourl: "",
      website: "",
      selected: [2],
      userdata: [],
      actionEmail: ""
    };
  },

  methods: {
    resetPassword(email) {
      this.actionEmail = email;
      this.dialog = false;
      var actionCodeSettings = {
        url: "http://www.pwgkenya.org",
        handleCodeInApp: false
      };
      auth
        .sendPasswordResetEmail(this.actionEmail, actionCodeSettings)
        .then(() => {
          this.success = true;
          this.alerttype = "success";
          this.alert =
            "An email with password reset instructions was sent to " +
            this.actionEmail;
        })
        .catch(error => {
          this.success = true;
          this.alerttype = "error";
          this.alert = "Action failed, please try again" + error;
        });
    },
    toggle(index) {
      const i = this.selected.indexOf(index);
      if (i > -1) {
        this.selected.splice(i, 1);
      } else {
        this.selected.push(index);
      }
    }
  },

  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    auth.onAuthStateChanged(user => {
      this.userid = user.uid;
    });
    db.collection("members")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          var idref = doc.id;
          if (doc.id === this.userid) {
            const data = {
              id: doc.id,
              name: doc.data().name,
              about: doc.data().about,
              email: doc.data().contactemail,
              email1: doc.data().contactemail1,
              phone1: doc.data().contactphone1,
              phone: doc.data().contactphone,
              contact: doc.data().contactname,
              contact1: doc.data().contactname1,
              photourl: doc.data().photourl,
              website: doc.data().website
            };
            this.userdata.push(data);
          }
        });
      });
  }
};
</script>



